interface IUltimateBeneficiaryAddress {
  streetLine1: string;
  streetLine2: string;
  city: string;
  state: string;
  stateTouched: boolean;
  postalCode: string;
  countryCode: string;
  countryName: string;
  countryCodeTouched: boolean;
}

interface IGetUltimateBeneficiaryAddress {
  streetLine1: string;
  streetLine2: string;
  city: string;
  state: string;
  stateTouched: boolean;
  postalCode: string;
  countryCode: string;
}

interface IUltimateBeneficiaryIdentity {
  idIssuingCountryCode: string;
  idIssuedCountryId: string;
  idIssuingCountryCodeTouched?: boolean;
  identityNumberType: string;
  identityNumberTypeTouched?: boolean;
  identityNumber: string;
  identityDocumentType: string;
  identityDocumentTypeTouched?: boolean;
}

interface IGetUltimateBeneficiaryIdentity {
  identityNumberType: string;
  identityNumber: string;
  identityDocumentType: string;
}

export enum IdentityTypeEnum {
  Id_Number = 0,
  Id_Document = 1,
}

export interface IUltimateBeneficiary
  extends IUltimateBeneficiaryAddress,
    IUltimateBeneficiaryIdentity {
  id: string | null;
  identityType: IdentityTypeEnum;
  firstName: string;
  lastName: string;
  birthDate: Date | null | any;
  email: string;
  phone: string;
  fullAddress?: string;
  countryId: string;
  open: boolean;
  identityDocumentFrontId: string | null;
  identityDocumentFrontBase64File?: string;
  identityDocumentFrontFileName?: string;
  identityDocumentFrontFileType?: string;
  identityDocumentBackId: string | null;
  identityDocumentBackBase64File?: string;
  identityDocumentBackFileName?: string;
  identityDocumentBackFileType?: string;
  identityDocumentDocFacing?: number;
}

export interface IGetUltimateBeneficiary {
  id: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  email: string;
  phone: string;
  address: IGetUltimateBeneficiaryAddress;
  identity: IGetUltimateBeneficiaryIdentity;
  docs: {
    frontDocument: string | null;
    backDocument: string | null;
  };
  identityType: string;
  identityTypeId: IdentityTypeEnum;
  countryId: string;
  countryName: string;
  idIssuedCountryId: string;
  idIssuedCountryName: string;
}

export interface IOnboardingDocument {
  base64File: string;
  fileName: string;
  bucketName: string;
}

export interface IOnboardingQuestionaire {
  sourceOfFund: string;
  transmitsCustomerFunds: string | boolean;
  estimatedAnnualRevenueUsd: string;
  estimatedMonthlyPayOut: string | number;
  sourceOfFundDescription: string;
}

export interface IBusinessAddressFormProps {
  streetLine1: string;
  streetLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  countryCode: string;
  countryName: string;
  countryId: string;
}

export interface IBusinessInfoFormProps {
  email: string;
  description: string;
  website: string;
  registrationNumber: string;
  businessType: string;
}

export interface IOnboarding extends IBusinessInfoFormProps {
  sourceOfFunds: string;
  address: IBusinessAddressFormProps;
  questionnaire: IOnboardingQuestionaire;
  ultimateBeneficialOwners: IUltimateBeneficiary[];
  formationDocument: IOnboardingDocument | null | string;
  ownershipDocument: IOnboardingDocument | null | string;
}
